<template>
  <div class="competence" id="competence">
    <DirectionArrows  :position="$props.position" :count="$props.count" :sidebar="$props.sidebar"/>

    <HelloWorld msg="Compétences"/>
    <div class="competences-container">
      <div class="competence">
        <h3>Front</h3>
        <div class="list">
          <div class="skill">
            <label>CSS3</label>
            <div class="level" data-level="8"></div>
          </div>
          <div class="skill">
            <label>HTML5</label>
            <div class="level" data-level="8"></div>
          </div>
          <div class="skill">
            <label>JAVASCRIPT</label>
            <div class="level" data-level="8"></div>
          </div>
          <div class="skill">
            <label>VUEJS</label>
            <div class="level" data-level="7"></div>
          </div>
        </div>
      </div>
      <div class="competence">
        <h3>Back</h3>
        <div class="list">
          <div class="skill">
            <label>PHP</label>
            <div class="level" data-level="8"></div>
          </div>
          <div class="skill">
            <label>LARAVEL</label>
            <div class="level" data-level="5"></div>
          </div>
          <div class="skill">
            <label>SYMPHONY</label>
            <div class="level" data-level="5"></div>
          </div>
          <div class="skill">
            <label>AJAX</label>
            <div class="level" data-level="7"></div>
          </div>
        </div>
      </div>
      <div class="competence" style="margin-top:20px;">
        <h3>Environnement</h3>
        <div class="list">
          <div class="skill">
            <label>MacOs</label>
            <div class="level" data-level="7"></div>
          </div>
          <div class="skill">
            <label>Linux</label>
            <div class="level" data-level="7"></div>
          </div>
          <div class="skill">
            <label>Windows</label>
            <div class="level" data-level="8"></div>
          </div>
        </div>
      </div>
      <div class="competence" style="margin-top:20px;">
        <h3>Autres</h3>
        <div class="list">
          <div class="skill">
            <label>Wordress</label>
            <div class="level" data-level="8"></div>
          </div>
          <div class="skill">
            <label>Prestashop</label>
            <div class="level" data-level="8"></div>
          </div>
          <div class="skill">
            <label>Photoshop</label>
            <div class="level" data-level="8"></div>
          </div>
        </div>

      </div>
    </div>

  </div>

</template>
<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import DirectionArrows from '@/components/ArrowsDirection.vue'
export default {
  name: 'Competence',
  components: {
    HelloWorld,
    DirectionArrows,
  },
  mounted() {
  }
  ,
  props: ['position', 'sidebar', 'count'],
  methods: {},

}
</script>
<style>
#competence {
  height: 80%;
  width: 40%;
  order: 3;
  transition: .3s;
}
.competence canvas{
  z-index: 100000;
  position: relative;
}
.competences-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.competences-container .competence {
  width: 40%;
  height: 200px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  background: rgba(1, 7, 20, 0.31);

}

.competences-container .competence h3 {
  margin-top: 0;
  text-transform: uppercase;
  text-align: left;
  letter-spacing: 3px;

}

.competences-container .competence label {
  margin: 0;
}

.competences-container .competence .list {
  width: 100%;
  text-align: left;
  overflow: auto;
}

.competences-container .competence .skill {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.competences-container .competence .list .level {
  width: 100px;
  height: 5px;
  background: rgba(1, 7, 20, 0.31);
  position: relative;
  border-radius: 20px;
}

.competences-container .competence .list .level::after {
  display: block;
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 20px;
  z-index: 1;
  height: 5px;
  background: rgb(255, 255, 255);
}

.level[data-level='5']:after {
  width: 50px;
}

.level[data-level='6']:after {
  width: 60px;
}

.level[data-level='7']:after {
  width: 70px;
}

.level[data-level='8']:after {
  width: 80px;
}

.level[data-level='9']:after {
  width: 90px;
}

.level[data-level='10']:after {
  width: 100px;
}

</style>
